export default {
  partyId: (state) => state.currentShop?.partyId,
  loadingTips: (state) => {
    let list = [...(state.loading_tips[state.loading_type] || []), ...state.loading_tips.common]
    let length = list.length
    let num = random(length)
    return list[num]
  },
  currentShop: (state) => state.currentShop || {},
  shopCode: (state) => state.currentShop?.uniqueCode || '',
  country: (state) => state.currentShop?.country || '',
  platformMapping: (state) => listToMap(state.nowPlatformList),
  merchantCode: (state) => state.userSession?.merchant?.merchantCode,
  isStore: (state) => state.currentShop?.shopType === 'STORE',
  microApplicationList(state) {
    return state.microApplicationList
  },
  subMerchantAppList(state) {
    return state.userInfo.subMerchantAppList
  },
}

function listToMap(list) {
  let obj = {}
  list.forEach((item) => {
    obj[item.code] = item.text
  })
  return obj
}

function random(len) {
  return Math.floor(Math.random() * len)
}
